import { render, staticRenderFns } from "./PutPassWord.vue?vue&type=template&id=5e138454&scoped=true&"
import script from "./PutPassWord.vue?vue&type=script&lang=js&"
export * from "./PutPassWord.vue?vue&type=script&lang=js&"
import style0 from "./PutPassWord.vue?vue&type=style&index=0&id=5e138454&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e138454",
  null
  
)

export default component.exports